import { yup } from '@guiker/yup-util'

export const legacySqlConfigSchema = yup
  .object({
    core: yup.string().required(),
    rentalApplication: yup.string().required(),
    paymentVerification: yup.string().required(),
  })
  .required()
